import React from 'react';
import { EyeIcon, CheckCircleIcon, ClockIcon, BookOpenIcon, CalendarIcon, ShieldCheck } from 'lucide-react';
const HeaderGlpInvestigationD = () => {
  return <header className="bg-white" style={{
    fontFamily: 'Georgia, Cambria, "Times New Roman", serif'
  }} data-id="element-17833" data-mp="3n2mdsum7s3n9">
      {/* Top black bar */}
      <div className="bg-black h-3 w-full" data-id="element-17834" data-mp="3d71ex5cfzjhq"></div>

      {/* Masthead section */}
      <div className="border-b border-gray-800 px-4 sm:px-6 py-4 sm:py-6" data-id="element-17835" data-mp="eovsrfbt1dib">
        <div className="text-center pb-3 sm:pb-4 mb-3 sm:mb-4" data-id="element-17836" data-mp="emt6959v22ic">
          <h2 className="font-serif text-2xl sm:text-3xl font-bold tracking-tight text-gray-900" data-id="element-17837" data-mp="9qua2viajg7d">
            TRADITIONAL MEDPUB
          </h2>
          <div className="text-xs uppercase tracking-widest text-gray-500 mt-2 font-medium" data-id="element-17838" data-mp="4sj4iwz13ruy">
            INDEPENDENT HEALTH INVESTIGATIONS SINCE 1982
          </div>
        </div>

        <div className="flex flex-col sm:grid sm:grid-cols-3 text-xs text-gray-600 border-b border-gray-300 pb-2 gap-1 sm:gap-0" data-id="element-17839" data-mp="2pi8il7rwr9ml">
          <div className="text-left" data-id="element-17840" data-mp="ijpwivbu9hbf">VOL. 128, NO. 43</div>
          <div className="text-left sm:text-center" data-id="element-17841" data-mp="ik94pkbosrc9">
            {(() => {
            const yesterday = new Date();
            yesterday.setDate(yesterday.getDate() - 1);
            return yesterday.toLocaleDateString('en-US', {
              weekday: 'long',
              month: 'long',
              day: 'numeric',
              year: 'numeric'
            }).toUpperCase();
          })()}
          </div>
          <div className="text-left sm:text-right" data-id="element-17842" data-mp="3vwj8kr5e8d5c">
            HEALTH & WELLNESS SECTION
          </div>
        </div>
      </div>

      {/* Article header */}
      <div className="px-4 sm:px-6 py-6 border-b border-gray-200" data-id="element-17843" data-mp="3m1hls1ylbn5x">
        <div className="max-w-4xl mx-auto" data-id="element-17844" data-mp="3qz9n1ml4klms">
          <div className="uppercase text-xs tracking-wider text-gray-500 font-medium border-b border-gray-200 pb-2 mb-4" data-id="element-17845" data-mp="3r0awjmmht02e">
            INVESTIGATIVE REPORT
          </div>

          <h1 className="font-serif text-2xl sm:text-4xl font-bold text-gray-900 leading-tight mb-5" data-id="element-17846" data-mp="3h1lg7ya8vno9">
            After 30 Years of Practice, I Stopped Prescribing Semaglutide
          </h1>

          <div className="flex items-start mb-5 border-b border-gray-200 pb-5" data-id="element-17847" data-mp="1ire7a8ajzztc">
            <div className="w-14 h-14 overflow-hidden rounded-full flex-shrink-0 mr-4 border border-gray-300" data-id="element-17848" data-mp="1dst9sgmoru8l">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3QGeAdkaxHnkiYL33dUYdV/Tom_Parham.jpg" alt="Dr. Tom Parham" className="w-full h-full object-cover" data-id="element-17849" data-mp="18u01d2m9atfa" />
            </div>
            <div className="flex-1" data-id="element-17850" data-mp="21inj4o7sr0o3">
              <div className="flex items-center" data-id="element-17851" data-mp="21jfd5ulqwqc9">
                <div className="font-medium text-gray-900 text-lg" data-id="element-17852" data-mp="1wjax25or1xmk">
                  By Dr. Tom Parham, MD, FACE
                </div>
                <div className="ml-2 flex items-center text-blue-600" data-id="element-17853" data-mp="1sihcnmain0yf">
                  <CheckCircleIcon className="h-4 w-4" data-id="element-17854" data-mp="l3w217g3pfu3" />
                  <span className="text-xs ml-1 font-medium" data-id="element-17855" data-mp="l5p6qh75lpzg">Verified</span>
                </div>
              </div>
              <div className="text-sm text-gray-600 mb-2" data-id="element-17856" data-mp="h4n9g5wsro04">
                Board-Certified Endocrinologist, 30 Years Clinical Practice
              </div>
              <div className="flex text-xs text-gray-500 items-center" data-id="element-17857" data-mp="2wsj24d5ygrp9">
                <div className="flex items-center mr-4" data-id="element-17858" data-mp="31quaejglqu5d">
                  <ClockIcon className="h-3 w-3 mr-1" data-id="element-17859" data-mp="31p9hey9xrj9m" />
                  <span data-id="element-17860" data-mp="36hkezuh7esz0">14 min read</span>
                </div>
                <div className="flex items-center" data-id="element-17861" data-mp="36j5d1u2q8u1m">
                  <EyeIcon className="h-3 w-3 mr-1" data-id="element-17862" data-mp="3bfly2femqsah" />
                  <span data-id="element-17863" data-mp="3gfgn0deuh7sw">31,542 views</span>
                </div>
              </div>
              <div className="flex items-center text-xs text-gray-500 mt-1" data-id="element-17864" data-mp="3ghkzhjqt7f4s">
                <ShieldCheck className="h-3.5 w-3.5 text-blue-600 mr-1 flex-shrink-0" data-id="element-17865" data-mp="3khljdjwogij8" />
                Medically Reviewed by{' '}
                <span className="text-blue-600 underline ml-1" data-id="element-17866" data-mp="1q32dd7cxfwwg">
                  Robert Hill, MD, FACP
                </span>
              </div>
            </div>
          </div>

          <p className="font-serif text-gray-700 text-base sm:text-lg mb-6 leading-relaxed border-l-4 border-gray-300 pl-4 italic" data-id="element-17867" data-mp="1v487n9m8js83">
            After three decades in endocrinology, I've prescribed thousands of
            medications. But when patients on semaglutide started reporting
            severe depression—and regulatory agencies ignored it—I decided to
            run a 16-month investigation. What I discovered will save you
            sleepless nights - and might actually change your life.
          </p>

          <div className="border-t border-gray-200 pt-3 text-xs text-gray-500 flex flex-wrap justify-between" data-id="element-17868" data-mp="c2eg60jat3r5">
            <div className="mb-1 flex items-center" data-id="element-17869" data-mp="qr0v4150jthu">
              <span className="font-medium mr-2" data-id="element-17870" data-mp="qslo3mboj4dl">Published by:</span>
              Traditional Medicine Publications
            </div>
            <div className="mb-1 flex items-center" data-id="element-17871" data-mp="3ugdvup81x79d">
              <span className="font-medium mr-2" data-id="element-17872" data-mp="3uet1azlqlobi">Published:</span>
              {(() => {
              const yesterday = new Date();
              yesterday.setDate(yesterday.getDate() - 1);
              return yesterday.toLocaleDateString('en-US', {
                month: 'long',
                year: 'numeric'
              });
            })()}
            </div>
          </div>
        </div>
      </div>

      {/* Author image */}
      <div className="px-4 sm:px-8 py-6 border-b border-gray-200" data-id="element-17873" data-mp="1uz817i4ty06p">
        <div className="max-w-4xl mx-auto" data-id="element-17874" data-mp="200ov2towcmds">
          <div className="sm:flex items-center" data-id="element-17875" data-mp="2npzqrwre3ql2">
            <div className="sm:w-1/3 mb-4 sm:mb-0 sm:mr-6" data-id="element-17876" data-mp="2nq9gdj8ivvq8">
              <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3QGeAdkaxHnkiYL33dUYdV/Tom_Parham.jpg" alt="Dr. Tom Parham in medical office" className="w-full rounded-lg shadow-md" data-id="element-17877" data-mp="2spcnrabz6e1d" />
            </div>
            <div className="sm:w-2/3" data-id="element-17878" data-mp="2ipvjmxcdg87i">
              <p className="text-sm text-gray-700 mb-2" data-id="element-17879" data-mp="2iotyu15k07cl">
                <span className="font-bold" data-id="element-17880" data-mp="139mycz2t5ziz">Dr. Tom Parham, MD, FACE</span> is a
                board-certified endocrinologist with 30 years of clinical
                experience specializing in diabetes management and metabolic
                disorders. Throughout his career, he has evaluated hundreds of
                pharmaceutical treatments and their long-term effects on
                patients.
              </p>
              <p className="text-sm text-gray-700" data-id="element-17881" data-mp="306ranktkack8">
                His investigative work focuses on identifying and solving
                medication side effects that fall through the cracks of official
                approval processes, helping patients achieve health outcomes
                without sacrificing quality of life.
              </p>
            </div>
          </div>
        </div>
      </div>
    </header>;
};
export default HeaderGlpInvestigationD;